import { useFetchContactsQuery, useSearchContactsQuery } from './api'

export const useFetchContacts = (activeTab, pagePath, searchQuery) => {
  const queryParams = {
    favorite: activeTab === 'favorites',
    pagePath
  }
  const {
    data: fetchedContacts,
    isLoading: isFetchLoading,
    isError: isFetchError,
    isSuccess: isFetchSuccess
  } = useFetchContactsQuery(queryParams)
  const {
    data: searchResults,
    isLoading: isSearchResultsLoading,
    isError: isSearchResultsErrorError,
    isSuccess: isSearchSuccess
  } = useSearchContactsQuery({ query: searchQuery, withEvents: true }, { skip: !searchQuery || searchQuery.length < 3 })
  const data = searchQuery && searchResults ? searchResults : fetchedContacts
  const isLoading = isSearchResultsLoading || isFetchLoading
  const isError = isFetchError || isSearchResultsErrorError
  const isSuccess = !isLoading && (isFetchSuccess || isSearchSuccess)

  return { data, isLoading, isError, isSuccess }
}

export const useSearchContacts = (searchQuery) => {
  const {
    data,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useSearchContactsQuery({ query: searchQuery, withEvents: false }, { skip: !searchQuery })

  return { data, isLoading, isError, isSuccess, isFetching }
}
